<template>
  <span>
    <test-language
      :testLocales="testLocales"
      :show="showLocaleSelection && showTest"
      @selected="selectedLocale = $event"
      @close="closeLocaleSelection"
    />
    <test
      v-if="!$apollo.loading && test && !reload"
      :test="test"
      :answerMap="answerMap"
      :questionNr="testQuestionNr"
      :show="showTest && !showLocaleSelection"
      @close="close"
      @try-again="reloadTest"
      @read-more="solveTestLater($event)"
      @test-done="testCompleted"
      @test_done_w_mistakes="testCompletedWithMistakes"
      @is-test-visible="changeShow($event)"
    />
  </span>
</template>

<script>
import Test from "@/components/Test";
import TestLanguage from "@/components/TestLanguage";

import TestQuery from "@/graphql/queries/instruction/test/TestToSolve.gql";

export default {
  components: {
    Test,
    TestLanguage,
  },

  props: ["testId"],

  data() {
    return {
      testQuestionNr: 1,
      answerMap: new Map(),
      reload: false,
      showTest: false,
      testLocales: [],
      showLocaleSelection: false,
      selectedLocale: null,
    };
  },
  watch: {
    test() {
      this.setAnswerMap();
      this.shuffleQuestions();
    },
    "$i18n.locale"() {
      this.showLocaleSelection = false;
      this.$apollo.queries.test.refresh();
    },
    selectedLocale(locale) {
      this.test.questions = this.test.questions.filter(
        (q) => q.language == locale
      );
      this.showLocaleSelection = false;
    },
  },

  methods: {
    closeLocaleSelection() {
      this.test.questions = this.test.questions.filter(
        (q) => q.language == this.test.questions[0].language
      );
      this.showLocaleSelection = false;
    },
    close() {
      this.setAnswerMap();
      this.testQuestionNr = 1;
      this.showTest = false;
      this.$apollo.queries.test.refresh();
    },
    changeShow(event) {
      if (event && this.showLocaleSelection) {
        this.reloadTest();
        this.$nextTick(() => {
          this.showTest = true;
        });
        return;
      }
      this.showTest = event;
    },
    resetData() {
      this.setAnswerMap();
      this.testQuestionNr = 1;
      this.showTest = false;
      this.reload = true;
      this.$nextTick(() => {
        this.reload = false;
      });
    },
    testCompleted() {
      this.resetData();
      this.$emit("test-done");
    },
    testCompletedWithMistakes() {
      this.resetData();
      this.$emit("test_done_w_mistakes");
    },

    setAnswerMap() {
      this.answerMap = new Map();
      this.test.questions.forEach((q) =>
        q.answers.forEach((a) => (this.answerMap[a.id] = false))
      );
    },
    solveTestLater(event) {
      this.answerMap = event.aMap;
      this.testQuestionNr = event.step;
      this.showTest = false;
    },
    reloadTest() {
      this.showTest = false;

      this.reload = true;
      this.setAnswerMap();
      this.testQuestionNr = 1;
      this.shuffleQuestions();
      this.$nextTick(() => {
        this.reload = false;
        this.$nextTick(() => {
          this.showTest = true;
        });
      });
    },

    shuffleQuestions() {
      var shuffle = require("knuth-shuffle").knuthShuffle;
      this.test.questions = shuffle(this.test.questions.slice(0));
    },
  },
  apollo: {
    test: {
      query: TestQuery,
      variables() {
        return {
          id: this.testId || this.$route.query.testId,
        };
      },
      update(data) {
        let t = data.test;
        this.testLocales = data.test.questions
          .map((q) => q.language)
          .filter((v, i, a) => a.indexOf(v) === i);
        if (data.test.questions.some((q) => q.language == this.$i18n.locale)) {
          t.questions = data.test.questions.filter(
            (q) => q.language == this.$i18n.locale
          );
        } else {
          this.showLocaleSelection = true;
        }

        return t;
      },
      skip() {
        return !(this.testId || this.$route.query.testId);
      },
    },
  },
};
</script>
